module.exports = __webpack_public_path__ + "img/background.1a4736f6.svg";